/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ExportTemplates$Params {
  projectId: string;
  templateIds?: Array<string>;
  query?: string;
  assigneeId?: string | null;
  typeIds?: Array<string>;
  priorityIds?: Array<string>;
  statusIds?: Array<string>;
  categoriesIds?: Array<string>;
  groupsIds?: Array<string>;
  dynamicFilters?: string;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'name' | '-name' | 'startDate' | '-startDate' | 'endDate' | '-endDate' | 'workPackageCategoryNames' | '-workPackageCategoryNames' | 'assigneeEmails' | '-assigneeEmails' | 'groupNames' | '-groupNames' | 'customFields' | '-customFields' | 'workPackageTypeName' | '-workPackageTypeName' | 'workPackagePriorityName' | '-workPackagePriorityName' | 'workPackageStatusName' | '-workPackageStatusName' | 'description' | '-description' | 'dynamicFormsSchema' | '-dynamicFormsSchema'>;
}

export function exportTemplates(http: HttpClient, rootUrl: string, params: ExportTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, exportTemplates.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('templateIds', params.templateIds, {});
    rb.query('query', params.query, {});
    rb.query('assigneeId', params.assigneeId, {});
    rb.query('typeIds', params.typeIds, {});
    rb.query('priorityIds', params.priorityIds, {});
    rb.query('statusIds', params.statusIds, {});
    rb.query('categoriesIds', params.categoriesIds, {});
    rb.query('groupsIds', params.groupsIds, {});
    rb.query('dynamicFilters', params.dynamicFilters, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/csv', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

exportTemplates.PATH = '/v0/templates/export';
